import type {
  SearchGameType,
  SearchGameAcclistType,
} from '@/pages/home/components/NavHeader/_config';
import { LANGUAGE_CN } from '@home/_config/config';

// 返回搜索游戏权限结合的游戏排序权重值
export const getSearchSortNum = (opinionNum: number, dashboardNum: number) => {
  switch (dashboardNum) {
    case 2: {
      if (opinionNum === 2) {
        return 1;
      }
      if (opinionNum === 1) {
        return 2;
      }
      return 5;
    }
    case 1: {
      if (opinionNum === 2) {
        return 3;
      }
      if (opinionNum === 1) {
        return 4;
      }
      return 6;
    }
    case 0: {
      if (opinionNum === 2) {
        return 7;
      }
      if (opinionNum === 1) {
        return 8;
      }
    }
    default:
      return 9;
  }
};

// 获取相同combineId游戏集合list
export const getCombineIDGameList = (gameListTemp: SearchGameType[]) => {
  const gameList = [...gameListTemp];
  const groupByCombineId = gameList?.reduce(
    (acclist: SearchGameAcclistType[], current: SearchGameType) => {
      const existItem: any = acclist?.find(
        (item: SearchGameAcclistType) => item.combineId && item.combineId === current.combine_id,
      );
      if (existItem) {
        if (existItem?.sortNum > current?.sortNum) {
          existItem.sortNum = current?.sortNum;
          existItem.combineList = [current, ...existItem?.combineList];
        } else {
          existItem?.combineList?.push(current);
        }
        if (existItem?.matchScore < current?.match_score) {
          existItem.matchScore = current?.match_score;
        }
      } else {
        acclist?.push({
          combineId: current?.combine_id,
          combineList: [current],
          sortNum: current?.sortNum,
          matchScore: current?.match_score,
        });
      }
      return acclist;
    },
    [],
  );
  return groupByCombineId;
};

// 拆解combine集合，排列所有搜索游戏
export const getListValueSplit = (listValueTemp: SearchGameAcclistType[]) => {
  const combineValueList: SearchGameType[] = [];
  const combineList = [...listValueTemp];
  combineList?.forEach((item: SearchGameAcclistType) => {
    const itemList = item?.combineList || [];
    itemList?.forEach((subItem: SearchGameType) => {
      combineValueList.push(subItem);
    });
  });
  return combineValueList;
};

// 通用搜索游戏排序规则方法
export const getSortSearchGamesCommon = (combineIDGameList: SearchGameType[]) => {
  const sortList = [...combineIDGameList];
  const sortListValue = sortList?.sort((a: any, b: any) =>
    // if (a?.sortNum === b?.sortNum) {
    //   return a?.secondaryOrder - b?.secondaryOrder;
    // }
    a?.sortNum - b?.sortNum
  );
  return sortListValue;
};

// 分为置顶和非置顶两部分游戏，因为若有多个置顶游戏，则置顶游戏也需要按规则排序
export const getSortSearchGames = (combineIDGameList: SearchGameType[], isSimilarMode?: boolean) => {
  const topList: any = [];
  const normalList: any = [];
  const similarityList: any = [];
  combineIDGameList?.forEach((item: SearchGameType) => {
    if (item?.isTop) {
      topList.push(item);
    } else if (!!isSimilarMode && item?.similarity && item?.similarity > 0.9) {
      similarityList.push(item);
    } else {
      normalList.push(item);
    }
  });
  return {
    topList,
    normalList,
    similarityList,
  };
};

const SPECIAL_RELEASE_TIME_TEXT_CONFIG: Record<string, { en: string; cn: string }> = {
  tba: {
    en: 'TBA',
    cn: '待定',
  },
  tobedecided: {
    en: 'To Be Decided',
    cn: '待定',
  },
  upcoming: {
    en: 'Upcoming',
    cn: '即将上线',
  },
};

export const formatReleaseTime = (
  // 当前语言环境
  locale: string,
  // 发布时间信息
  releaseTimeData?: {
    // 是否为特殊字符的Release Time
    isSpecialReleaseTime?: boolean;
    // 真实发布日期
    realReleaseTime?: string;
    // 通用
    releaseTime?: string;
    // 英文
    releaseTimeEN?: string;
    // 中文
    releaseTimeCN?: string;
  },
  // 为空时的占位符
  placeholder = '-',
): string => {
  const { isSpecialReleaseTime = false, realReleaseTime, releaseTime, releaseTimeEN, releaseTimeCN } = releaseTimeData || {};
  if (realReleaseTime) {
    return realReleaseTime;
  }

  if (isSpecialReleaseTime) {
    // 特殊字符的Release Time的兜底值
    const specialReleaseTimeDefault = releaseTimeEN || releaseTimeCN || releaseTime || placeholder || '';
    return (locale === LANGUAGE_CN ? releaseTimeCN : releaseTimeEN) || specialReleaseTimeDefault;
  }

  // 常规的Release Time的兜底值
  const commonReleaseTimeDefault = releaseTimeEN || placeholder || '';
  const commonReleaseTime = releaseTime || commonReleaseTimeDefault;
  const normalizedReleaseTime = commonReleaseTime.toLowerCase().replace(/\s+/g, '');
  const specialReleaseTimeText = SPECIAL_RELEASE_TIME_TEXT_CONFIG[normalizedReleaseTime];
  if (specialReleaseTimeText) {
    if (locale === LANGUAGE_CN) {
      return specialReleaseTimeText.cn;
    }

    return specialReleaseTimeText.en;
  }

  return commonReleaseTime;
};

export const getOpinionGameId = (opinionInfo: any[],combineIdList: any) => {
  let resId = '';
  if(Array.isArray(opinionInfo)  && opinionInfo?.length > 0 ) {
    const filteredOpinions = opinionInfo.filter(item => item.opinion_permissions === true) || [];
    if(filteredOpinions) {
      const perIdList = filteredOpinions?.map(item => item.edition_unified_id);
      if(perIdList.includes(combineIdList.pc)) {
        resId =  combineIdList.pc;
      } else if(perIdList.includes(combineIdList.console)) {
        resId =  combineIdList.console;
      }
    }
  }
  return resId;
};
